export default "__VITE_ASSET__33888177__"